export default __webpack_public_path__ + "static/media/trust-maticlaunch.c8cb86f7.svg";